import PropTypes from "prop-types";
import React from "react";

import Label from '../formsUi/common/label/Label';
import RadioButton from '../formsUi/radioButton/RadioButton';
import ValidationMessage from '../formsUi/common/validation/ValidationMessage';

const FormRadioButtonControls = ({
    keyId,
    dataField,
    labelName,
    name,
    value,
    error,
    formSetting = {},
    overRideProps = {},
    fieldSetting = {},
    isRequired,
    onChange,
    onValidation,
    onBlur,
    onActionChange,
    ...otherProps
}) => {

    const handleRadioChange = (event) => {
        if (onChange) {
            const matched = fieldSetting?.options?.find(
                (opt) => String(opt.value) === event.target.value
            );
            onChange(dataField, matched ? matched.value : event.target.value);
        }
    };

    const handleOnBlur = () => {
        if (onBlur) onBlur(dataField);
    };

    return (
        <>
            {fieldSetting?.subTitle && (
                <div className="section-title">
                    <h5>{fieldSetting.subTitle}</h5>
                </div>
            )}
            <div className="input-label-part">
                {labelName && <Label labelName={labelName} htmlFor={name} isRequired={isRequired} />}
                <RadioButton
                    name={name}
                    onChange={handleRadioChange}
                    onBlur={handleOnBlur}
                    dataField={dataField}
                    error={error}
                    formSetting={formSetting}
                    options={fieldSetting?.options}
                    value={value ?? fieldSetting?.defaultOption}
                    isDisable={formSetting?.isViewOnly || fieldSetting?.isDisable || overRideProps?.isDisable}
                    {...otherProps}
                    {...fieldSetting} />
            </div>
            <ValidationMessage error={error || ""} />
        </>
    );
};

FormRadioButtonControls.propTypes = {
    keyId: PropTypes.string,
    dataField: PropTypes.string.isRequired,
    labelName: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    formSetting: PropTypes.object,
    overRideProps: PropTypes.object,
    fieldSetting: PropTypes.shape({
        subTitle: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.object),
        isFormControl: PropTypes.bool,
        defaultOption: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        isDisable: PropTypes.bool,
    }),
    isRequired: PropTypes.bool,
    onChange: PropTypes.func,
    onValidation: PropTypes.func,
    onBlure: PropTypes.func,
    onActionChange: PropTypes.func
};

export default FormRadioButtonControls;